<template>
  <div class="landing-page">
    <header>
      <div class="header-container">
        <div class="brand-wrapper">
          <a href="#" class="home-link">
            <span class="brand-span">
              <img src="../assets/logo.svg" alt="" />
            </span>
          </a>
        </div>
      </div>
    </header>
    <div class="sections">
      <section class="section-hero">
        <div class="gradient1"></div>
        <div class="gradient2"></div>
        <div class="container promo">
          <div class="row frow">
            <div class="hero-intro col-xs-12 col-lg-4">
              <h1 class="premium-display">You &#128156; merch?</h1>
              <h3>one merch tool to rule them all</h3>
              <div class="actions">
                <a
                  :href="spotifyLink"
                  @click="trackSpotifySignup"
                  class="spotify-button"
                >
                  <img src="../assets/spotify.svg" alt="" />
                  <span>Continue with Spotify</span>
                </a>
                <div class="signup-wrapper">
                  <span class="signup" @click="openLoginModal">
                    or continue with email
                  </span>
                </div>

                <login-modal />
              </div>
            </div>
            <div class="promos col-xs-12 col-lg-8">
              <div class="row">
                <div class="merch-results">
                  <ul>
                    <merch-preview
                      :merch="merch"
                      v-for="merch in merchItems"
                      :key="merch.id"
                    />
                  </ul>
                </div>
              </div>
            </div>
            <!-- <a href="#whatis" class="scroll-down">
              <div class="arrow-scroll-down">
                <img src="../assets/arrow-down.svg" alt="" />
              </div>
            </a> -->
          </div>
        </div>
      </section>

      <section class="section-whatis">
        <div id="whatis"></div>
        <div class="container whatis-container">
          <div class="text-center">
            <h1>What is <span class="drip">Driphound?</span></h1>
          </div>
          <div class="row">
            <div class="col">
              <div class="whatis">
                <p>
                  Driphound is an app that helps you keep track of all of your
                  favorite artists' official merchandise using one tool.
                </p>
                <p>
                  Currently, Driphound only links to official merch stores
                  preferred by the artist, and we do not take a cut for sales or
                  affiliate marketing.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section-features">
        <div class="container features-container">
          <div class="text-center">
            <h1>Why use <span class="drip">Driphound?</span></h1>
          </div>
          <div class="feature row">
            <div class="col-lg-4">
              <ul>
                <li
                  @mouseover="video = 'feed'"
                  @click="video = 'feed'"
                  :class="{ active: video == 'feed' }"
                >
                  One merch feed for all of your merch needs
                </li>
                <li
                  @mouseover="video = 'following'"
                  @click="video = 'following'"
                  :class="{ active: video == 'following' }"
                >
                  Stay up to date with all of your favorite merch shops and
                  artists.
                </li>
                <li
                  @mouseover="video = 'search'"
                  @click="video = 'search'"
                  :class="{ active: video == 'search' }"
                >
                  Discover new shops quickly and easily
                </li>
                <li
                  @mouseover="video = 'notifications'"
                  @click="video = 'notifications'"
                  :class="{ active: video == 'notifications' }"
                >
                  Keep up with the latest trends in the world of merch
                </li>
              </ul>
            </div>
            <div class="col-lg-8 video-box-wrapper">
              <div class="video-box">
                <img src="../assets/chrometop.png" alt="" class="chrome-top" />
                <video
                  v-show="video == 'feed'"
                  autoplay
                  preload
                  loop
                  muted
                  playsinline
                  poster="../assets/feedposter.jpg"
                >
                  <source src="../assets/feed.mp4" type="video/mp4" />
                  <source src="../assets/feed.webm" type="video/webm" />
                </video>
                <video
                  v-show="video == 'following'"
                  autoplay
                  preload
                  loop
                  muted
                  playsinline
                  poster="../assets/followingposter.jpg"
                >
                  <source src="../assets/following.mp4" type="video/mp4" />
                  <source src="../assets/following.webm" type="video/webm" />
                </video>
                <video
                  v-show="video == 'search'"
                  autoplay
                  preload
                  loop
                  muted
                  playsinline
                  poster="../assets/searchposter.jpg"
                >
                  <source src="../assets/search.mp4" type="video/mp4" />
                  <source src="../assets/search.webm" type="video/webm" />
                </video>
                <video
                  v-show="video == 'notifications'"
                  autoplay
                  preload
                  loop
                  muted
                  playsinline
                  poster="../assets/notificationsposter.jpg"
                >
                  <source src="../assets/notifications.mp4" type="video/mp4" />
                  <source
                    src="../assets/notifications.webm"
                    type="video/webm"
                  />
                </video>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section-links">
        <div class="links-container">
          <div class="row">
            <div class="col">
              <h1>Make the most of Driphound</h1>
            </div>
            <ul class="links-list">
              <li class="col-lg-4">
                <h3>Easily manage your merch</h3>
                <p>
                  Tired of going to multiple merch shops across the internet?
                  Those days are over with the Driphound merch feed.
                </p>
              </li>
              <li class="col-lg-4">
                <h3>Don't miss a merch drop again</h3>
                <p>
                  Get real-time updates when new merch drops and out-of-stock
                  merch comes back in.
                </p>
              </li>
              <li class="col-lg-4">
                <h3>Sign up for a free account</h3>
                <p>
                  Start saving time, and staying ahead of the merch curve with
                  Driphound today. To play and share music without the app, all
                  within your
                </p>
              </li>
            </ul>
            <div>
              <div class="actions">
                <a
                  :href="spotifyLink"
                  @click="trackSpotifySignup"
                  class="spotify-button"
                >
                  <img src="../assets/spotify.svg" alt="" />
                  <span>Continue with Spotify</span>
                </a>
                <div class="signup-wrapper">
                  <span class="signup" @click="openLoginModal">
                    or continue with email
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <footer>
      <nav class="footer-nav">
        <div class="socials-row">
          <ul class="socials">
            <li>
              <a href="https://www.facebook.com/driphound1" target="_blank">
                <img src="../assets/facebook.svg" alt="" />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/driphound" target="_blank">
                <img src="../assets/twitter.svg" alt="" />
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/drip.hound/" target="_blank">
                <img src="../assets/instagram.svg" alt="" />
              </a>
            </li>
          </ul>
        </div>
        <div class="bottom-links">
          <ul class="bottom-links-list">
            <li><a href="#">About</a></li>
            <li><a href="http://blog.driphound.com">Blog</a></li>
          </ul>
          <span class="brand">DRIPHOUND 2021</span>
        </div>
      </nav>
    </footer>
  </div>
</template>

<script>
import MerchPreview from "@/components/MerchPreview.vue";
import LoginModal from "@/components/LoginModal.vue";
import { mapGetters } from "vuex";
import { EventBus, EventBusEvents } from "../event-bus";

export default {
  name: "LandingPage",
  components: {
    MerchPreview,
    LoginModal,
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "auth/isLoggedIn",
    }),
    spotifyLink() {
      return `${process.env.VUE_APP_API_URL}/v1/auth/spotify`;
    },
  },
  created() {
    if (this.isLoggedIn) {
      this.$router.replace("/feed");
    }
  },
  data() {
    return {
      video: "feed",
      merchItems: [
        {
          id: 0,
          artist: "Flume",
          title: "Car Window Tee",
          link: "https://shop.flumemusic.com/apparel/car-window-tee",
          image:
            "https://s3.amazonaws.com/dev1.mtimg.com/product_photos/imgs/000/047/853/full/FLUME_2CarTee-1.png?1568132215",
        },
        {
          id: 1,
          artist: "Taylor Swift",
          title: "Fearless (Taylor's Version) Back Cover Tee",
          link: "https://store.taylorswift.com/collections/new-album-collection/products/fearless-taylors-version-back-cover-t-shirt",
          image:
            "https://cdn.shopify.com/s/files/1/0011/4651/9637/products/FEARLESSBACKCOVERTEEFRONT_84b7966e-0285-478d-98f0-00160c126fa2.png?v=1617466380",
        },
        {
          id: 2,
          artist: "Post Malone",
          title: "Posty Co Mic Longsleeve",
          link: "https://shop.postmalone.com/products/posty-co-mic-longsleeve",
          image:
            "https://cdn.shopify.com/s/files/1/0293/0514/3340/products/PMLLIVEPHOTOLSFRONT_700x.png?v=1605132749",
        },
        {
          id: 3,
          artist: "The KID Laroi",
          title: "LAROI ❤️ HAT",
          link: "https://shoptkl.com/products/laroi-heart-hat",
          image:
            "https://cdn.shopify.com/s/files/1/0408/6264/6432/products/new-hat_740x.png?v=1613346083",
        },
        {
          id: 4,
          artist: "Denzel Curry",
          title: "Unlocked 1.5 Black Tee",
          link: "https://bodega.lomavistarecordings.com/collections/denzel-curry/products/denzel-curry-kenny-beats-unlocked-1-5-black-shortsleeve",
          image:
            "https://cdn.shopify.com/s/files/1/0339/9771/7548/products/blackmangatee.png?v=1614264327",
        },
        {
          id: 5,
          artist: "Phoebe Bridgers",
          title: "Punisher (Red & Swirly) Vinyl",
          link: "https://store.phoebefuckingbridgers.com/collections/frontpage/products/punisher-black-vinyl-lp",
          image:
            "https://cdn.shopify.com/s/files/1/2436/7337/files/Phoebe_Bridgers_Punisher_large.png?v=1593176442",
        },
      ],
    };
  },
  methods: {
    trackSpotifySignup() {
      this.trackEvent("Auth", "Click", "Spotify");
    },
    openLoginModal() {
      EventBus.$emit(EventBusEvents.OpenSignupModal);
      // this.$modal.show("auth-modal");
      // this.trackEvent("Auth", "Open Modal", "Email");
    },
  },
};
</script>

<style lang="scss" scoped>
.landing-page {
  width: 100%;
  overflow-x: hidden;
  padding-left: 0;
  padding-right: 0;
  // scroll-behavior: smooth;
  flex-direction: column;
  color: white;
}

header {
  background-color: #111;
  position: fixed;
  z-index: 1020;
  right: 0;
  left: 0;
  top: 0;
  min-height: 54px;
  &.modal-open {
    @include on-mobile {
      display: none;
    }
  }
  .header-container {
    padding: 0 18px;
    justify-content: space-between;
    align-items: flex-start;
    .brand-wrapper {
      display: inline-block;
      .brand-span {
        text-shadow: none;
        border: 0;
        width: 100%;
        height: 100%;
        font: 0/0 a;
        display: inline-block;
        color: white;
        img {
          width: 230px;
        }
      }
    }
  }
}

.sections {
  width: 100%;
  overflow-x: hidden;
  padding-left: 0;
  padding-right: 0;
  section {
    width: 100%;
    position: relative;
    overflow: hidden;
  }
}

.section-hero {
  text-align: center;
  display: block;
  .gradient1 {
    background-color: #509bf5;
    background-image: linear-gradient(90deg, #1f637985 0%, #552f6da8 80%);
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .gradient2 {
    background-image: linear-gradient(transparent, #000);
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .promo {
    display: flex;
    padding-top: 110px;
    padding-bottom: 70px;
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;
    max-width: 100%;
    @media (min-width: 768px) {
      width: 750px;
      max-width: inherit;
      padding-top: 140px;
      padding-bottom: 110px;
    }
    @media (min-width: 992px) {
      width: 970px;
    }
    @media (min-width: 1200px) {
      width: 1170px;
    }
    .frow {
      @media (max-width: 767px) {
        overflow-x: auto;
      }
    }
    .hero-intro {
      text-align: center;
      z-index: 1;
      align-self: center;
      @media (min-width: 997px) {
        text-align: left;
      }
      small {
        color: #fff;
        font-weight: 700;
        font-size: 12px;
      }
      .premium-display {
        margin-top: 0;
        margin-bottom: 0;
        font-size: 48px;
        line-height: 1.1;
        @media (min-width: 992px) {
          font-size: 43px;
        }
        @media (min-width: 1200px) {
          font-size: 48px;
        }
      }
      h3 {
        margin-top: 12px;
        margin-bottom: 20px;
        font-size: 24px;
        line-height: 1.3;
      }
      .actions {
        @media (min-width: 1200px) {
          width: 90%;
          margin: 0;
        }
      }
      .spotify-button {
        display: inline-flex;
        align-items: center;
        margin: 16px 0;
        margin-bottom: 10px;
        font-size: 14px;
        line-height: 1.3;
        border-radius: 500px;
        padding: 19px 30px 21px;
        color: #fff;
        background-color: #1db954;
        transition-duration: 0.3s;
        border-width: 0;
        letter-spacing: 1px;
        min-width: 160px;
        text-transform: uppercase;
        white-space: normal;
        font-weight: 700;
        text-align: center;
        vertical-align: middle;
        text-decoration: none;
        @include on-hover {
          background-color: #1ed760;
          text-decoration: none;
        }
        span {
          margin-left: 4px;
          text-align: left;
          font-size: 13px;
          font-weight: 600;
          @media (min-width: 1200px) {
            font-size: 14px;
          }
        }
      }
      .signup-wrapper {
        padding-bottom: 16px;
        text-align: center;
        color: #dedede;
        .signup {
          font-size: 14px;
          @include on-hover {
            cursor: pointer;
            color: #fff;
            font-weight: 500;
          }
          &:active {
            font-weight: 500;
          }
          strong {
            display: inline-block;
          }
        }
      }
    }
  }
}
.signup-wrapper {
  .signup {
    font-size: 14px;
  }
}
.scroll-down {
  position: relative;
  bottom: -24px;
  animation: MoveUpDown 1.5s ease-out infinite;
  font-size: 16px;
  line-height: 1;
  display: none;
  left: 0;
  @media (min-width: 768px) {
    display: inline-block;
  }
  .arrow-scroll-down {
    width: 44px;
    height: 44px;
    display: block;
    margin: 0 auto;
    img {
      width: 32px;
      height: 43px;
    }
  }
}
.promos {
  .row {
    .merch-results {
      overflow-x: auto;
      ul {
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: center;
        padding: 0;
        margin: 0;
        width: 100%;
        @media (max-width: 767px) {
          flex-flow: row nowrap;
          justify-content: flex-start;
          white-space: nowrap;
          overflow-x: auto;
        }
        li {
          @media (max-width: 767px) {
            // background: yellow;
            // display: inline-block;
            float: none;
            vertical-align: top;
            width: 65%;
            flex-basis: 65%;
            max-width: 65%;
            position: relative;
            padding-top: 12px;
          }
        }
      }
    }
  }
}

.section-whatis {
  color: #fff;
  background-color: #1e3264;
  background-image: linear-gradient(270deg, #1f637985 0%, #552f6da8 80%);
  #whatis {
    display: block;
    height: 92px;
    margin-top: -92px;
    visibility: hidden;
  }
  .whatis-container {
    padding-top: 60px;
    padding-bottom: 0;
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;
    @media (min-width: 768px) {
      width: 750px;
    }
    @media (min-width: 992px) {
      width: 970px;
    }
    @media (min-width: 1200px) {
      width: 1170px;
    }
    h1 {
      margin-bottom: 22px;
      font-size: 48px;
      line-height: 1.2;
      vertical-align: middle;
      @media (min-width: 768px) {
        margin-bottom: 60px;
      }
      .drip {
        text-decoration: none;
        @include on-hover {
          @media (min-width: 768px) {
            font-family: "Nosifer", cursive;
            font-size: 30.5px;
            vertical-align: middle;
          }
        }
      }
    }
    p {
      font-size: 24px;
      line-height: 1.5;
    }
  }
}

.section-features {
  color: #fff;
  background-color: #1e3264;
  background-image: linear-gradient(270deg, #1f637985 0%, #552f6da8 80%);
  #features {
    display: block;
    height: 92px;
    margin-top: -92px;
    visibility: hidden;
  }
  .features-container {
    padding-top: 60px;
    padding-bottom: 80px;
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;
    @media (min-width: 768px) {
      width: 750px;
    }
    @media (min-width: 992px) {
      width: 970px;
    }
    @media (min-width: 1200px) {
      width: 1170px;
    }
    h1 {
      margin-bottom: 22px;
      font-size: 48px;
      line-height: 1.2;
      vertical-align: middle;
      @media (min-width: 768px) {
        margin-bottom: 60px;
      }
      .drip {
        text-decoration: none;
        @include on-hover {
          @media (min-width: 768px) {
            font-family: "Nosifer", cursive;
            font-size: 30.5px;
            vertical-align: middle;
          }
        }
      }
    }
    .feature {
      flex-direction: row;
      ul,
      ol {
        height: 100%;
        padding: 10px;
        display: flex;
        list-style-type: "◇ ";
        flex-direction: column;
        justify-content: space-between;
        text-align: left;
        margin: 0;
        margin-left: 12px;
        font-size: 24px;
        line-height: 1.5;
        padding-bottom: 35px;
        li {
          line-height: 1.5;
          margin: 15px 0;
          &.active {
            font-weight: 700;
            color: #1db954;
          }
          @media (min-width: 768px) {
            @include on-hover {
              cursor: pointer;
              font-weight: 500;
              color: #1db954;
            }
          }
        }
      }
      .video-box-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        .video-box {
          width: 100%;
          img {
            width: 100%;
          }
          video {
            width: 100%;
          }
        }
      }
    }
  }
}
.section-links {
  text-align: left;
  color: #000;
  background-color: white;
  @media (min-width: 1200px) {
    width: 1170px !important;
    margin: auto;
  }
  .links-container {
    padding-top: 40px;
    padding-bottom: 80px;
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;
    h1 {
      font-size: 48px;
      line-height: 1.2;
      margin: 0.5em 0 0.25em;
      margin-top: 0;
      text-align: center;
    }
    .links-list {
      display: flex;
      flex-flow: row wrap;
      justify-content: flex-start;
      margin: 0;
      padding: 0;
      li {
        display: flex;
        flex-flow: column nowrap;
        padding: 10px 20px;
        h3 {
          font-size: 24px;
          line-height: 1.4;
          margin-top: 24px;
          margin-bottom: 12px;
        }
        p {
          margin: 0.5em 0 1em;
          font-size: 16px;
          line-height: 1.5;
        }
      }
    }
  }
}

footer {
  padding: 80px 0 50px;
  // padding-bottom: 120px;
  padding-top: 10px;
  background: #000;
  font-size: 16px;
  .footer-nav {
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    // width: 970px;
    padding: 0 15px;
    .socials-row {
      margin: 0 0 5px 5px;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      flex-direction: row;
      flex-shrink: initial;
      .socials {
        margin: 20px 0 0;
        padding: 0;
        li {
          margin-right: 15px;
          display: inline-block;
          a {
            border-radius: 50%;
            background-color: #222326;
            width: 54px;
            height: 54px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            color: white;
            @include on-hover {
              text-decoration: none;
            }
            img {
              color: #222326;
              fill: #dedede;
              @include on-hover {
                filter: brightness(0) invert(1);
                text-decoration: none;
                // fill: #1db954;
              }
            }
          }
        }
      }
    }
    .bottom-links {
      width: 100%;
      display: flex;
      flex-direction: row;
      .bottom-links-list {
        margin: 0 45px 0 0;
        padding: 0 0 0 15px;
        li {
          margin-right: 24px;
          padding: 0;
          list-style: none;
          display: inline-block;
          line-height: normal;
          letter-spacing: 0;
          a {
            padding: 1em 0;
            font-size: 12px;
            display: flex;
            flex-shrink: 0;
            align-items: center;
            white-space: nowrap;
            text-decoration: none;
            color: #919496;
            background: transparent;
            @include on-hover {
              text-decoration: none;
              color: #fff;
            }
          }
        }
      }
      .brand {
        margin: 0 15px 0 auto;
        padding: 1em 0;
        font-size: 12px;
        flex-shrink: 0;
        color: #919496;
      }
    }
  }
}

.actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}
.spotify-button {
  display: inline-flex;
  align-items: center;
  margin: 16px 0;
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 1.3;
  border-radius: 500px;
  padding: 19px 30px 21px;
  color: #fff;
  background-color: #1db954;
  transition-duration: 0.3s;
  border-width: 0;
  letter-spacing: 1px;
  min-width: 160px;
  text-transform: uppercase;
  white-space: normal;
  font-weight: 700;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
  @include on-hover {
    color: #fff;
    background-color: #1ed760;
    text-decoration: none;
  }
  span {
    margin-left: 10px;
    text-align: left;
  }
}
.signup-wrapper {
  text-align: center;
  color: #999;
  .signup {
    font-size: 14px;
    @include on-hover {
      cursor: pointer;
      color: #555;
      font-weight: 500;
    }
    strong {
      display: inline-block;
    }
  }
}

@keyframes MoveUpDown {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-12%);
  }
}
</style>
